<template>
  <div :style="{
    'background': data.infoItme.bjColor,
    'padding': `${data.infoItme.sBj} ${data.infoItme.yeBj} ${data.infoItme.xBj}`
  }">
    <el-carousel trigger="click">
      <el-carousel-item v-for="(item, index) in data.carouselImage" :key="index">
        <img :src="item.src ? item.src : imgSrc" />
        <h3>{{ item.title }}</h3>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
import infoImg from '../../assets/image-upload.jpg'
export default {
  name: 'carouselPreview',
  props: {
    data: Object
  },
  data () {
    return {
      imgSrc: infoImg
    }
  }
}
</script>
<style scoped>
img {
  width: 100%;
  height: 100%;
}

h3 {
  margin: 0;
  width: 100%;
  position: absolute;
  bottom: 0;
  padding: 0 6px;
  line-height: 40px;
  color: #ffffff;
  background-color: rgba(0, 0, 0, 0.3);
}
</style>



// WEBPACK FOOTER //
// src/components/carousel/carouselView.vue